// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto:100,300,400);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* On applique le style à la page entière */
/* body {
  margin: 0;
  padding: 0;
  text-align: center;
  color: #fff;
  font-family: 'Roboto', sans-serif;
  font-size: 36px;
  font-weight: 100;
  overflow: hidden;
  animation: bg 5s linear infinite;
} */

  
.AppPageEmptySpace0,
.AppPageEmptySpace1,
.AppPageEmptySpace2,
.AppPageEmptySpace3,
.AppPageEmptySpace4,
.AppPageEmptySpace5,
.AppPageEmptySpace6 {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
  text-align: center;
  font-family: 'Roboto', sans-serif;
  font-size: 20px;
  font-weight: 100;
  width: 100%;
  height: 100%;
}


.AppPageEmptySpace0 { animation: bg0 10s infinite;  color: #000080}
.AppPageEmptySpace1 { animation: bg1 10s infinite;  color: #000000}
.AppPageEmptySpace2 { animation: bg2 10s infinite;  color: #FF0000}
.AppPageEmptySpace3 { animation: bg3 10s infinite;  color: #800080}
.AppPageEmptySpace4 { animation: bg4 10s infinite;  color: #000000}
.AppPageEmptySpace5 { animation: bg5 10s infinite;  color: #615959}
.AppPageEmptySpace6 { animation: bg6 10s infinite;  color: #000000}


/* Conteneur des textes animés */
.droppingEmpty-texts {
  display: inline-block;
  width: 180px;
  text-align: left;
  height: 2px;
  vertical-align: -2px;
}

/* Les éléments individuels animés */
.droppingEmpty-texts > div {
  font-size: 0px;
  opacity: 0;
  margin-left: -38px;
  position: absolute;
  font-weight: 200;
  box-shadow: 0px 60px 25px -20px rgba(0, 0, 0, 0.5);
}

/* Définition des timings pour chaque mot */
.droppingEmpty-texts > div:nth-child(1) {
  animation: roll 5s linear infinite 0s;
}
.droppingEmpty-texts > div:nth-child(2) {
  animation: roll 5s linear infinite 1s;
}
.droppingEmpty-texts > div:nth-child(3) {
  animation: roll 5s linear infinite 2s;
}
.droppingEmpty-texts > div:nth-child(4) {
  animation: roll2 5s linear infinite 3s;
}

/* Animations clés */
@keyframes roll {
  0% {
    font-size: 0px;
    opacity: 0;
    margin-left: -30px;
    margin-top: 0px;
    transform: rotate(-25deg);
  }
  3% {
    opacity: 1;
    transform: rotate(0deg);
  }
  5% {
    font-size: inherit;
    opacity: 1;
    margin-left: 0px;
    margin-top: 0px;
  }
  20% {
    font-size: inherit;
    opacity: 1;
    margin-left: 0px;
    margin-top: 0px;
    transform: rotate(0deg);
  }
  27% {
    font-size: 0px;
    opacity: 0.5;
    margin-left: 20px;
    margin-top: 100px;
  }
  100% {
    font-size: 0px;
    opacity: 0;
    margin-left: -30px;
    margin-top: 0px;
    transform: rotate(15deg);
  }
}

@keyframes roll2 {
  0% {
    font-size: 0px;
    opacity: 0;
    margin-left: -30px;
    margin-top: 0px;
    transform: rotate(-25deg);
  }
  3% {
    opacity: 1;
    transform: rotate(0deg);
  }
  5% {
    font-size: inherit;
    opacity: 1;
    margin-left: 0px;
    margin-top: 0px;
  }
  30% {
    font-size: inherit;
    opacity: 1;
    margin-left: 0px;
    margin-top: 0px;
    transform: rotate(0deg);
  }
  37% {
    font-size: 1500px;
    opacity: 0;
    margin-left: -1000px;
    margin-top: -800px;
  }
  100% {
    font-size: 0px;
    opacity: 0;
    margin-left: -30px;
    margin-top: 0px;
    transform: rotate(15deg);
  }
}

@keyframes bg0 { /* Rouge très pâle -> pâle */
    0%   { background: hsl(0, 100%, 97%); }  /* 5% saturation */
    25%  { background: hsl(0, 100%, 95%); }  /* 10% */
    50%  { background: hsl(0, 100%, 93%); }  /* 20% */
    75%  { background: hsl(0, 100%, 90%); }  /* 30% */
    100% { background: hsl(0, 100%, 87%); }  /* 40% */
  }
  
  @keyframes bg1 { /* Orange très pâle -> pâle */
    0%   { background: hsl(30, 100%, 97%); }
    25%  { background: hsl(30, 100%, 95%); }
    50%  { background: hsl(30, 100%, 93%); }
    75%  { background: hsl(30, 100%, 90%); }
    100% { background: hsl(30, 100%, 87%); }
  }
  
  @keyframes bg2 { /* Jaune très pâle -> pâle */
    0%   { background: hsl(50, 100%, 97%); }
    25%  { background: hsl(50, 100%, 95%); }
    50%  { background: hsl(50, 100%, 93%); }
    75%  { background: hsl(50, 100%, 90%); }
    100% { background: hsl(50, 100%, 87%); }
  }
  
  @keyframes bg3 { /* Vert très pâle -> pâle */
    0%   { background: hsl(120, 100%, 97%); }
    25%  { background: hsl(120, 100%, 95%); }
    50%  { background: hsl(120, 100%, 93%); }
    75%  { background: hsl(120, 100%, 90%); }
    100% { background: hsl(120, 100%, 87%); }
  }
  
  @keyframes bg4 { /* Bleu très pâle -> pâle */
    0%   { background: hsl(200, 100%, 97%); }
    25%  { background: hsl(200, 100%, 95%); }
    50%  { background: hsl(200, 100%, 93%); }
    75%  { background: hsl(200, 100%, 90%); }
    100% { background: hsl(200, 100%, 87%); }
  }
  
  @keyframes bg5 { /* Indigo très pâle -> pâle */
    0%   { background: hsl(260, 100%, 97%); }
    25%  { background: hsl(260, 100%, 95%); }
    50%  { background: hsl(260, 100%, 93%); }
    75%  { background: hsl(260, 100%, 90%); }
    100% { background: hsl(260, 100%, 87%); }
  }
  
  @keyframes bg6 { /* Violet très pâle -> pâle */
    0%   { background: hsl(290, 100%, 97%); }
    25%  { background: hsl(290, 100%, 95%); }
    50%  { background: hsl(290, 100%, 93%); }
    75%  { background: hsl(290, 100%, 90%); }
    100% { background: hsl(290, 100%, 87%); }
  }
  
  
  `, "",{"version":3,"sources":["webpack://./src/includes/pageInside/pageEmptySpace.css"],"names":[],"mappings":"AAEA,2CAA2C;AAC3C;;;;;;;;;;GAUG;;;AAGH;;;;;;;EAOE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;;AAGA,sBAAsB,2BAA2B,GAAG,cAAc;AAClE,sBAAsB,2BAA2B,GAAG,cAAc;AAClE,sBAAsB,2BAA2B,GAAG,cAAc;AAClE,sBAAsB,2BAA2B,GAAG,cAAc;AAClE,sBAAsB,2BAA2B,GAAG,cAAc;AAClE,sBAAsB,2BAA2B,GAAG,cAAc;AAClE,sBAAsB,2BAA2B,GAAG,cAAc;;;AAGlE,gCAAgC;AAChC;EACE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA,2CAA2C;AAC3C;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,sCAAsC;AACxC;;AAEA,oBAAoB;AACpB;EACE;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,uBAAuB;EACzB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,eAAe;IACf,uBAAuB;EACzB;EACA;IACE,iBAAiB;IACjB,UAAU;IACV,oBAAoB;IACpB,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,eAAe;IACf,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB,4BAA4B;IACzC,OAAO,6BAA6B,EAAE,GAAG,kBAAkB;IAC3D,OAAO,6BAA6B,EAAE,GAAG,QAAQ;IACjD,OAAO,6BAA6B,EAAE,GAAG,QAAQ;IACjD,OAAO,6BAA6B,EAAE,GAAG,QAAQ;IACjD,OAAO,6BAA6B,EAAE,GAAG,QAAQ;EACnD;;EAEA,iBAAiB,6BAA6B;IAC5C,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;EACzC;;EAEA,iBAAiB,4BAA4B;IAC3C,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;IACvC,OAAO,8BAA8B,EAAE;EACzC;;EAEA,iBAAiB,2BAA2B;IAC1C,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;EAC1C;;EAEA,iBAAiB,2BAA2B;IAC1C,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;EAC1C;;EAEA,iBAAiB,6BAA6B;IAC5C,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;EAC1C;;EAEA,iBAAiB,6BAA6B;IAC5C,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;IACxC,OAAO,+BAA+B,EAAE;EAC1C","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400');\n\n/* On applique le style à la page entière */\n/* body {\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  color: #fff;\n  font-family: 'Roboto', sans-serif;\n  font-size: 36px;\n  font-weight: 100;\n  overflow: hidden;\n  animation: bg 5s linear infinite;\n} */\n\n  \n.AppPageEmptySpace0,\n.AppPageEmptySpace1,\n.AppPageEmptySpace2,\n.AppPageEmptySpace3,\n.AppPageEmptySpace4,\n.AppPageEmptySpace5,\n.AppPageEmptySpace6 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  text-align: center;\n  font-family: 'Roboto', sans-serif;\n  font-size: 20px;\n  font-weight: 100;\n  width: 100%;\n  height: 100%;\n}\n\n\n.AppPageEmptySpace0 { animation: bg0 10s infinite;  color: #000080}\n.AppPageEmptySpace1 { animation: bg1 10s infinite;  color: #000000}\n.AppPageEmptySpace2 { animation: bg2 10s infinite;  color: #FF0000}\n.AppPageEmptySpace3 { animation: bg3 10s infinite;  color: #800080}\n.AppPageEmptySpace4 { animation: bg4 10s infinite;  color: #000000}\n.AppPageEmptySpace5 { animation: bg5 10s infinite;  color: #615959}\n.AppPageEmptySpace6 { animation: bg6 10s infinite;  color: #000000}\n\n\n/* Conteneur des textes animés */\n.droppingEmpty-texts {\n  display: inline-block;\n  width: 180px;\n  text-align: left;\n  height: 2px;\n  vertical-align: -2px;\n}\n\n/* Les éléments individuels animés */\n.droppingEmpty-texts > div {\n  font-size: 0px;\n  opacity: 0;\n  margin-left: -38px;\n  position: absolute;\n  font-weight: 200;\n  box-shadow: 0px 60px 25px -20px rgba(0, 0, 0, 0.5);\n}\n\n/* Définition des timings pour chaque mot */\n.droppingEmpty-texts > div:nth-child(1) {\n  animation: roll 5s linear infinite 0s;\n}\n.droppingEmpty-texts > div:nth-child(2) {\n  animation: roll 5s linear infinite 1s;\n}\n.droppingEmpty-texts > div:nth-child(3) {\n  animation: roll 5s linear infinite 2s;\n}\n.droppingEmpty-texts > div:nth-child(4) {\n  animation: roll2 5s linear infinite 3s;\n}\n\n/* Animations clés */\n@keyframes roll {\n  0% {\n    font-size: 0px;\n    opacity: 0;\n    margin-left: -30px;\n    margin-top: 0px;\n    transform: rotate(-25deg);\n  }\n  3% {\n    opacity: 1;\n    transform: rotate(0deg);\n  }\n  5% {\n    font-size: inherit;\n    opacity: 1;\n    margin-left: 0px;\n    margin-top: 0px;\n  }\n  20% {\n    font-size: inherit;\n    opacity: 1;\n    margin-left: 0px;\n    margin-top: 0px;\n    transform: rotate(0deg);\n  }\n  27% {\n    font-size: 0px;\n    opacity: 0.5;\n    margin-left: 20px;\n    margin-top: 100px;\n  }\n  100% {\n    font-size: 0px;\n    opacity: 0;\n    margin-left: -30px;\n    margin-top: 0px;\n    transform: rotate(15deg);\n  }\n}\n\n@keyframes roll2 {\n  0% {\n    font-size: 0px;\n    opacity: 0;\n    margin-left: -30px;\n    margin-top: 0px;\n    transform: rotate(-25deg);\n  }\n  3% {\n    opacity: 1;\n    transform: rotate(0deg);\n  }\n  5% {\n    font-size: inherit;\n    opacity: 1;\n    margin-left: 0px;\n    margin-top: 0px;\n  }\n  30% {\n    font-size: inherit;\n    opacity: 1;\n    margin-left: 0px;\n    margin-top: 0px;\n    transform: rotate(0deg);\n  }\n  37% {\n    font-size: 1500px;\n    opacity: 0;\n    margin-left: -1000px;\n    margin-top: -800px;\n  }\n  100% {\n    font-size: 0px;\n    opacity: 0;\n    margin-left: -30px;\n    margin-top: 0px;\n    transform: rotate(15deg);\n  }\n}\n\n@keyframes bg0 { /* Rouge très pâle -> pâle */\n    0%   { background: hsl(0, 100%, 97%); }  /* 5% saturation */\n    25%  { background: hsl(0, 100%, 95%); }  /* 10% */\n    50%  { background: hsl(0, 100%, 93%); }  /* 20% */\n    75%  { background: hsl(0, 100%, 90%); }  /* 30% */\n    100% { background: hsl(0, 100%, 87%); }  /* 40% */\n  }\n  \n  @keyframes bg1 { /* Orange très pâle -> pâle */\n    0%   { background: hsl(30, 100%, 97%); }\n    25%  { background: hsl(30, 100%, 95%); }\n    50%  { background: hsl(30, 100%, 93%); }\n    75%  { background: hsl(30, 100%, 90%); }\n    100% { background: hsl(30, 100%, 87%); }\n  }\n  \n  @keyframes bg2 { /* Jaune très pâle -> pâle */\n    0%   { background: hsl(50, 100%, 97%); }\n    25%  { background: hsl(50, 100%, 95%); }\n    50%  { background: hsl(50, 100%, 93%); }\n    75%  { background: hsl(50, 100%, 90%); }\n    100% { background: hsl(50, 100%, 87%); }\n  }\n  \n  @keyframes bg3 { /* Vert très pâle -> pâle */\n    0%   { background: hsl(120, 100%, 97%); }\n    25%  { background: hsl(120, 100%, 95%); }\n    50%  { background: hsl(120, 100%, 93%); }\n    75%  { background: hsl(120, 100%, 90%); }\n    100% { background: hsl(120, 100%, 87%); }\n  }\n  \n  @keyframes bg4 { /* Bleu très pâle -> pâle */\n    0%   { background: hsl(200, 100%, 97%); }\n    25%  { background: hsl(200, 100%, 95%); }\n    50%  { background: hsl(200, 100%, 93%); }\n    75%  { background: hsl(200, 100%, 90%); }\n    100% { background: hsl(200, 100%, 87%); }\n  }\n  \n  @keyframes bg5 { /* Indigo très pâle -> pâle */\n    0%   { background: hsl(260, 100%, 97%); }\n    25%  { background: hsl(260, 100%, 95%); }\n    50%  { background: hsl(260, 100%, 93%); }\n    75%  { background: hsl(260, 100%, 90%); }\n    100% { background: hsl(260, 100%, 87%); }\n  }\n  \n  @keyframes bg6 { /* Violet très pâle -> pâle */\n    0%   { background: hsl(290, 100%, 97%); }\n    25%  { background: hsl(290, 100%, 95%); }\n    50%  { background: hsl(290, 100%, 93%); }\n    75%  { background: hsl(290, 100%, 90%); }\n    100% { background: hsl(290, 100%, 87%); }\n  }\n  \n  \n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
